// i18n area 'vms' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.fr-FR.meta.json.
import type { enUS } from './vms'

export const frFR: typeof enUS = {
  vms: {
    spof: {
      title: 'Indépendance du nœud',
      single: 'Point de défaillance unique',
      alternativesNow: 'Alternatives maintenant',
      structural: 'Par construction',
      binding: 'Contrainte déterminante',
      movableNow: 'Migrable maintenant',
    },
    title: 'Machines virtuelles',
    migratingChip: 'Migration en cours',
    templateChip: 'Template',
    expendableTooltip: 'Dans un cluster dégradé, elle est parmi les premières à tomber et peut ne pas redémarrer après la perte d\'un nœud.',
    expendableHaTooltip: 'Toujours redémarrée tant que le cluster est sain ; dans un cluster dégradé, les VM protégées passent d\'abord — elle peut être arrêtée ou rester éteinte jusqu\'à ce que le cluster soit de nouveau complet, puis elle revient d\'elle-même.',
    viewDetails: 'Voir les détails',
    profileLegacy: 'Autre OS',
    hugePagesNone: 'Aucune — mémoire ordinaire',
    hugePages2M: 'Pages de 2 MiB',
    hugePages1G: 'Pages de 1 GiB',
    searchPlaceholder: 'Rechercher par nom',
    name: 'Nom',
    vcpus: 'vCPU',
    memory: 'Mémoire',
    ipAddresses: 'Adresses IP',
    noIp: 'Aucune IP',
    authorityNode: 'Authority',
    authorityNextStart: 'assignée au prochain démarrage',
    scope: 'Scope',
    empty: 'Aucune machine virtuelle',
    loadError: 'Impossible de charger les machines virtuelles — le backend TVirt est-il joignable ?',
    filterOverlay: 'réseau overlay',
    filterDisk: 'disque',
    filterImage: 'image',
    filteredBy: 'Filtrées par {kind}',
    filterPhase: 'Phase',
    filterProtection: 'Protection',
    filterAll: 'Toutes',
    filterScopePlaceholder: 'Filtrer par scope',
    filtersToggle: 'Filtres',
    scopeTree: {
      title: 'Scopes',
      all: 'Tout le cluster',
      noChildren: 'Aucun sous-scope ici',
      recursive: 'Inclure les descendants',
      collapse: 'Replier le panneau des scopes',
      up: "Monter d'un niveau",
      countTooltip: '{direct} VM dans ce scope · {total} avec les descendants'
    },
    isoPicker: {
      catalog: 'Catalogue',
      unknownCatalog: 'Hors des catalogues visibles',
      noIsos: 'Aucune image ISO prête dans ce catalogue'
    },
    actionsHeader: 'Actions',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tags',
      age: 'Âge',
      disk: 'disque',
      disks: 'disques',
      empty: 'Aucun template — marquez comme template une VM éteinte, ou clonez une VM comme template.',
      clone: 'Cloner / deploy',
      editTags: 'Modifier les tags',
      exportAction: 'Exporter vers le catalogue (.tvtpl)',
      exportTitle: 'Exporter vers le catalogue',
      exportSubmit: 'Exporter',
      exportError: "L'export a échoué",
      exportHint: 'Le template est empaqueté dans une archive .tvtpl (manifest hardware + chaque disque aplati en qcow2) comme nouveau fichier Template VM dans le catalogue choisi. Les NIC, les supports CD/DVD et cloud-init ne voyagent pas — la spec du format liste chaque omission délibérée.',
      exportName: 'Nom du fichier',
      exportNameHint: 'Vide = <template>-export-<n>',
      exportStorageDefault: 'Le storage des métadonnées du template',
      importAction: 'Importer depuis un catalogue',
      importTitle: 'Importer depuis un catalogue',
      importHint: "Un fichier Template VM ready du catalogue choisi devient un template de l'inventaire : le format du fichier (tvtpl, ova, ovf ou qcow2 nu) décide seul de la façon dont il s'importe — vous ne choisissez que le fichier.",
      importFile: 'Fichier de catalogue',
      importFileHint: "Seuls les fichiers ready s'importent — un fichier en plein upload n'est pas importable",
      importNoFiles: "Aucun fichier Template VM ready dans ce catalogue — envoyez-en ou exportez-en un d'abord"
    },
    templateDetail: {
      quickDeploy: 'Compatibilité QuickDeploy',
      quickDeployNone: 'Non déclarée',
      quickDeployHint: 'Déclarez-la seulement si l\'image golden contient cloud-init (Linux) ou cloudbase-init après sysprep /generalize (Windows) : la plateforme fait confiance à la déclaration et ne regarde jamais dans l\'invité.',
      notFound: 'Template introuvable',
      frozen: 'La configuration hardware est congelée : reconvertissez le template en VM pour la modifier. Le nom, les notes et les tags restent modifiables.',
      storage: 'Storage',
      size: 'Taille',
      configTitle: 'Configuration (congelée)',
      usbClasses: 'Classes USB requises',
      gpuClasses: 'Classes GPU requises'
    },
    sharedDisksTab: {
      title: 'Disques partagés',
      sharing: 'Partage',
      sharingNone: 'Un seul attachement',
      sharingMultiwriter: 'Écriture partagée (multiwriter)',
      sharingReadonly: 'Lecture seule partagée',
      usedBy: 'Utilisé par',
      attachedTo: 'Attaché à',
      notAttached: 'Attaché à aucune VM',
      changeSharing: 'Changer le mode de partage',
      changeSharingTitle: 'Mode de partage',
      changeSharingLocked: 'Le mode ne change que lorsqu\'aucune VM n\'utilise le disque',
      sharingChanged: 'Mode de partage mis à jour.',
      lun: 'LUN entière',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Numéro de série',
      antiAffinityWarning: 'Deux membres ou plus tournent sur le même nœud sans règle d\'anti-affinité : la panne d\'un nœud les emporte tous',
      antiAffinityCreate: 'Créer la règle',
      createSourceLun: 'Adopter une LUN entière de la cible',
      createLunNumber: 'Numéro de LUN (identifiant de namespace en NVMe)',
      createLunHint: 'Rien n\'est alloué : la taille est observée sur le périphérique à l\'adoption',
      noPr: 'Pas de SCSI-3 persistent reservations dans cette version : un Windows Failover Cluster avec disque partagé classique n\'est pas validé ; les clusters qui se coordonnent par le réseau (GFS2/OCFS2, RHEL HA, bases à disque partagé) le sont'
    },
    unusedDisksTab: {
      title: 'Disques non utilisés',
      attach: 'Attacher à une VM',
      attachTitle: 'Attacher à une VM',
      vm: 'Machine virtuelle',
      noVms: 'Aucune VM disponible',
      noSlots: 'Aucun slot libre sur cette VM',
      create: 'Créer un disque',
      createTitle: 'Créer un disque',
      createSourceBlank: 'Disque vide',
      createSourceImage: 'Depuis une image du catalogue',
      createImage: 'Image',
      createImageEmpty: 'Aucune image de modèle de VM prête dans les catalogues visibles',
      createSizeFromImageHint: 'Prérempli avec la taille virtuelle de l\'image — elle ne peut que croître',
      convert: 'Convertir en template VM…',
      convertOnlyQcow2: "Seuls les disques qcow2 se convertissent — raw n'est pas un format de template enregistrable",
      convertTitle: 'Convertir en template VM',
      convertSubmit: 'Convertir (détruit le disque)',
      convertError: 'Impossible de démarrer la conversion',
      convertWarning: "DESTRUCTIF : le disque devient un fichier template VM dans le catalogue choisi — même storage, zéro byte copié — et CESSE D'EXISTER comme disque. Pas de retour en arrière, sinon en créant un nouveau disque depuis le template.",
      convertNameHint: 'Le nom du fichier de catalogue — par défaut celui du disque',
      convertConfirm: "J'ai compris : le disque sera détruit",
      convertStarted: 'Conversion démarrée — le template apparaît dans le catalogue à la fin de la task.',
      storageLockHint: "Le storage ne change que via l'action Déplacer",
      source: 'Provenance',
      sourceClone: "Clone d'un autre disque",
      sourceCloneLinked: "Linked clone d'un autre disque",
      sourceImage: 'Créé depuis une image',
      sourceBlank: 'Créé vide',
      allocated: 'Alloué / taille virtuelle',
      observedAt: 'Observé le',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Aucun snapshot'
    },
    phase: {
      defined: 'Jamais allumée',
      starting: 'En démarrage',
      running: 'En exécution',
      stopping: 'En arrêt',
      stopped: 'Éteinte',
      paused: 'En pause',
      failed: 'En erreur',
      deleting: 'En suppression'
    },
    stopCause: {
      'api': 'Arrêtée par TVirt (action ou API)',
      'guest-shutdown': "Shutdown initié par le système d'exploitation guest",
      'crash': 'Crash du guest',
      'qemu-exit': "Le processus QEMU s'est terminé de façon inattendue",
      'host-reboot': 'Le nœud a été redémarré',
      'migrated': 'Migrée vers un autre nœud',
      'fenced': 'Terminée par le fencing HA (nœud revenu)'
    },
    detail: {
      notFound: 'Machine virtuelle introuvable',
      details: 'Détails',
      id: 'ID',
      scope: 'Scope',
      profile: 'Profil hardware',
      firmware: 'Firmware',
      firmwareFile: 'Version du firmware UEFI',
      firmwareUpdate: 'Mise à jour disponible',
      firmwareUpdateHint: "La plateforme fournit un firmware UEFI plus récent. La mise à jour n'est jamais automatique : elle s'applique VM éteinte, quand vous le décidez.",
      arch: 'Architecture',
      node: 'Nœud',
      bootOrder: 'Ordre de boot',
      agent: "État de l'agent",
      agentConnected: 'Connecté',
      agentNotConnected: 'Non connecté',
      protected: 'Protégée',
      linkedClones: 'Clones liés',
      restartPolicy: 'Politique de redémarrage',
      preferredNode: 'Nœud préféré',
      noPreference: 'Aucune préférence (placement automatique)',
      preferNodes: 'Tags de nœud préférés',
      requireNodes: 'Tags de nœud obligatoires',
      noPlacementTags: 'Aucun',
      placementTag: 'Tag',
      placementValue: 'Valeur',
      placementAddTag: 'Ajouter un tag',
      proximityHa: 'HA de TVirt Proximity',
      proximityHaRestarts: 'redémarrages HA',
      proximityHaGaveUp: 'crash loop — HA a renoncé',
      failoverProtection: 'Protection en mode dégradé',
      protectionProtected: 'Protégée',
      protectionExpendable: 'Sacrifiable en mode dégradé',
      protectionInherit: 'Hériter',
      lastStop: 'Dernier arrêt',
      yes: 'Oui',
      no: 'Non',
      tabOverview: "Vue d'ensemble",
      tabSnapshots: 'Snapshots',
      tabBackups: 'Sauvegardes',
      hardware: 'Hardware',
      name: 'Nom',
      hwSystem: 'Système',
      hwCpu: 'CPU',
      hwMemory: 'Mémoire',
      hwBoot: 'Démarrage',
      hwIdentity: 'Identité',
      hwCluster: 'Cluster et agent',
      cpuTopology: 'Topologie CPU',
      cpuModel: 'Modèle de CPU',
      cpuLimit: 'Limite CPU',
      cpuWeight: 'Poids CPU',
      cpuNested: "Virtualisation imbriquée",
      cpuNestedHint: "Expose vmx/svm à l'invité (uniquement avec le modèle CPU host). Sur une VM allumée, le changement s'applique au prochain power cycle (PendingRestart) ; le placement n'admet que les nœuds avec nested activé.",
      unlimited: 'Illimité',
      memory: 'Mémoire',
      balloon: 'Balloon',
      hugePages: 'Pages énormes',
      hugePagesTradeoff: 'Moins de travail de traduction d\'adresses et de la mémoire qui ne part jamais sur le disque ; en échange la réservation reste bloquée sur le nœud tant que la VM tourne, la mémoire n\'est plus dédupliquée et le démarrage échoue si le nœud n\'a pas assez de pages libres.',
      disks: 'Disques',
      cdroms: 'Lecteurs CD/DVD',
      nics: 'Interfaces réseau',
      slot: 'Slot',
      disk: 'Disque',
      encrypted: 'Chiffré',
      image: 'Image',
      emptyDrive: 'Lecteur vide',
      emptyOption: '(vide)',
      network: 'Réseau',
      mac: 'MAC',
      connected: 'Connectée',
      unplugged: 'Débranchée',
      noDevices: 'Aucun',
      screenshot: 'Screenshot',
      capturedAt: 'Capturé à',
      noCapture: 'Aucune capture',
      snapshotName: 'Nom',
      snapshotCreated: 'Créé',
      snapshotMemory: 'Mémoire incluse',
      noSnapshots: 'Aucun snapshot',
      pendingRestart: 'Modifications en attente : elles seront appliquées au prochain power cycle.',
      applied: 'appliqué',
      appliedHint: "La VM tourne avec cette valeur — celle configurée s'applique au prochain power cycle.",
      actionError: "L'action a échoué",
      actionStillRunning: 'L\'action est toujours en cours — son issue n\'est pas encore connue',
      tabConsole: 'Console',
      consoleConnect: 'Connecter',
      consoleDisconnect: 'Déconnecter',
      consoleConnecting: 'Connexion…',
      consoleReconnecting: 'Connexion…',
      consoleUnavailable: 'La console est disponible lorsque la VM est en exécution ou en pause.',
      consoleError: 'La connexion à la console a échoué',
      consoleTaken: 'Session console reprise par {user}',
      consoleReconnect: 'Reconnecter',
      consoleCtrlAltDel: 'Ctrl+Alt+Suppr',
      consoleHold: 'Maintenez {key} enfoncée',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Ouvrir en plein écran dans un nouveau tab',
      consoleLoadFailed: 'VM introuvable ou permissions insuffisantes',
      consoleClose: 'Fermer',
      tabStats: 'Statistiques',
      tabTasks: 'Tasks',
      tabLogs: 'Logs',
      statsCpu: 'CPU',
      statsMemory: 'Mémoire',
      statsDisk: 'I/O disque',
      statsRange: 'Intervalle',
      statsNoData: "Aucune donnée sur l'intervalle sélectionné — les statistiques sont échantillonnées pendant que la VM tourne.",
      statsError: 'Impossible de charger les statistiques',
      cpuUsage: 'Utilisation',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Utilisée',
      memGuestAvailable: 'Disponible (guest)',
      schema: 'Schéma',
      consoleProtocol: 'Console',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage des métadonnées',
      startupOnBoot: 'Démarrage au boot',
      startupOrder: 'Ordre de démarrage',
      startupDelay: 'Délai de démarrage',
      seconds: 's',
      enabled: 'Activé',
      disabled: 'Désactivé'
    },
    actionsAvailable: 'Actions disponibles',
    actions: {
      start: 'Démarrer',
      stop: 'Arrêter',
      pause: 'Pause',
      resume: 'Reprendre',
      reset: 'Reset',
      migrate: 'Migrer',
      clone: 'Cloner',
      moveStorage: 'Déplacer vers un storage…',
      moveScope: 'Déplacer vers un scope…',
      openConsole: 'Ouvrir la console',
      forceStop: "Forcer l'arrêt",
      markTemplate: 'Marquer comme template',
      unmarkTemplate: 'Reconvertir en VM',
      error: "Impossible d'exécuter l'action"
    },
    cordon: {
      confirmTitle: 'Le nœud est en maintenance',
      confirmHint:
        'Le cordon ne peut pas être abaissé tant que le store du cluster est indisponible. En confirmant, vous déclarez le savoir : la VM démarre là malgré tout, et le consentement reste enregistré sur la tâche.',
      confirm: 'Démarrer quand même'
    },
    markTemplate: {
      confirmTitle: 'Marquer {name} comme template ?',
      confirmBody: "La configuration se congèle et la VM ne pourra plus s'allumer — seulement se cloner, ou redevenir VM. Le nom, les notes et les tags restent modifiables.",
      confirm: 'Marquer comme template',
      moved: '{name} est maintenant un template — déplacé dans le tab Templates.'
    },
    unmarkTemplate: {
      confirmTitle: 'Reconvertir {name} en VM ?',
      confirmBody: 'Le template redevient une VM ordinaire : modifiable et démarrable (le prochain démarrage la place sur un nœud).',
      confirm: 'Reconvertir en VM',
      moved: '{name} est à nouveau une machine virtuelle — déplacée dans le tab Machines virtuelles.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Par tag de nœud',
      hint: 'tag=valeur, séparés par des virgules (en AND) : le décideur choisit parmi les nœuds correspondants',
      invalid: 'Format invalide — utilisez tag=valeur, séparés par des virgules',
      resolved: 'Membres correspondants : {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrer',
      target: 'Nœud de destination',
      auto: 'Automatique (Proximity)',
      hint: "La VM se déplace sans power cycle. Chaque storage qu'elle touche doit être partagé ; une VM en pause migre en pause.",
      error: 'La migration a été refusée'
    },
    moveStorage: {
      title: 'Déplacer vers un storage',
      submit: 'Déplacer',
      target: 'Storage de destination',
      noTargets: "Aucun storage n'accepte de disques",
      hint: 'Tous les disques de la VM éteinte voyagent vers le storage choisi, un à la fois, en conservant leur id — ceux déjà à destination sont sautés. La progression vit dans la page des tasks.',
      error: 'Le déplacement de storage a été refusé'
    },
    moveScope: {
      title: 'Déplacer vers un scope',
      submit: 'Déplacer',
      target: 'Scope de destination',
      hint: "La VM change de scope immédiatement — l'id et les disques restent, ses disques owned la suivent, et elle peut rester allumée. Aujourd'hui elle vit dans {scope}. Qui la voit change avec le scope.",
      error: 'Le déplacement de scope a été refusé'
    },
    start: {
      title: 'Démarrer la VM',
      submit: 'Démarrer',
      target: 'Nœud de destination',
      auto: 'Automatique (conseillé)',
      recommended: 'conseillé',
      hint: "Choisissez un nœud de destination ou laissez Proximity décider parmi les candidats valides. Les nœuds qui ne peuvent pas l'héberger sont désactivés avec le motif.",
      error: 'Impossible de démarrer la VM'
    },
    console: {
      media: 'Lecteurs CD/DVD',
      mediaGuestToolsHint: "Contient les TVirt Guest Tools — d'ici vous pouvez les éjecter ou retirer le lecteur",
      slotOpsDeferred: "Sur ce profil, l'ajout et le retrait de lecteurs s'appliquent au prochain power cycle (les changements de support sont immédiats).",
      mountGuestTools: 'Monter TVirt Guest Tools',
      ejectGuestTools: 'Éjecter TVirt Guest Tools',
      bootOrder: 'Ordre de boot',
      bootOrderHint: "Le nouvel ordre s'enregistre tout de suite et s'applique au prochain power cycle — la session console reste connectée."
    },
    snapshots: {
      create: 'Créer un snapshot',
      createTitle: 'Créer un snapshot',
      createSubmit: 'Créer',
      name: 'Nom',
      nameHint: 'Lettres, chiffres, point, tiret, underscore.',
      consistencyHint: 'La cohérence est automatique : le guest agent gèle les filesystems quand il répond ; sinon la VM se met en pause un instant autour du snapshot.',
      memory: 'Inclure la mémoire',
      memoryHint: 'Capture la RAM vive : la restauration reprend la VM en exécution. Exige tous les disques en qcow2.',
      currentChip: 'Vous êtes ici',
      revert: 'Restaurer',
      revertTitle: 'Restaurer {name} ?',
      revertBody: "Les disques reviennent à l'état du snapshot ; tout ce qui s'est passé après est perdu. Un snapshot disques-seuls exige la VM arrêtée.",
      delete: 'Supprimer',
      deleteTitle: 'Supprimer le snapshot {name} ?',
      deleteBody: 'Le point de restauration disparaît ; le contenu des disques reste intact.',
      deleteMergeHint: 'Son delta fusionne dans {children} : chaque point de restauration ultérieur reste valide.',
      deleteDuplication: 'J’accepte la duplication',
      deleteDuplicationHint: 'Le delta est copié dans chacun des {count} lecteurs (les snapshots enfants et, si celui-ci est le courant, la tête active) : l’espace occupé peut croître au lieu de diminuer.',
      error: "L'opération sur le snapshot a été refusée"
    },
    clone: {
      title: 'Cloner la VM',
      submit: 'Cloner',
      name: 'Nom de la copie',
      storage: 'Storage de destination des disques',
      sameStorage: 'Le même que la source',
      full: 'Copie complète',
      fullHint: 'Copie chaque byte et coupe le lien avec les disques source. Le default est un linked clone : instantané, mais enchaîné à la source (qcow2 seulement).',
      hint: "Le clone garde la configuration et le firmware de la source ; les adresses MAC et l'identité TPM sont neuves.",
      markAs: 'Type du clone',
      markAsInheritVm: 'Comme la source (VM)',
      markAsInheritTemplate: 'Comme la source (template)',
      markAsVm: 'Machine virtuelle',
      markAsTemplate: 'Template',
      markAsHintVm: 'Choisissez Template pour promouvoir la copie en une seule étape.',
      markAsHintTemplate: 'Choisissez Machine virtuelle pour faire le deploy depuis ce template en une seule étape.',
      error: 'Le clonage a été refusé'
    },
    bulk: {
      selected: 'sélectionnées',
      deleteTitle: {
        one: 'Supprimer {count} VM sélectionnée ?',
        many: 'Supprimer les {count} VM sélectionnées ?',
        other: 'Supprimer les {count} VM sélectionnées ?'
      },
      deleteBody: 'Chaque VM passe les mêmes gardes que le delete individuel ; les refus sont rapportés par élément.',
      done: 'acceptées',
      refused: 'refusées'
    },
    delete: {
      button: 'Supprimer',
      confirmTitle: 'Supprimer {name} ?',
      confirmBody: "La machine virtuelle et les disques qui lui appartiennent seront supprimés. L'opération n'est pas réversible.",
      keepDisks: 'Conserver les disques',
      keepDisksHint: 'Les disques créés avec la VM restent dans leur storage comme disques autonomes.',
      confirm: 'Supprimer',
      cancel: 'Annuler',
      error: 'La suppression a échoué',
      blockedPhase: "Arrêtez d'abord la VM",
      blockedProtected: "La VM est protégée — retirez d'abord la protection",
      blockedDeleting: 'Suppression déjà en cours'
    },
    logs: {
      title: 'Logs',
      subtitle: 'Frames de log structurées des tasks qui touchent cette VM',
      when: 'Quand',
      task: 'Task',
      level: 'Niveau',
      message: 'Message',
      empty: 'Encore aucun log',
      loadError: 'Impossible de charger les logs — le backend TVirt est-il joignable ?'
    },
    stop: {
      title: 'Arrêter la machine virtuelle',
      modeGraceful: 'Arrêt graceful',
      modeGracefulHint: "Le système d'exploitation guest est invité à s'éteindre naturellement (ACPI) ; s'il ignore la demande, l'arrêt forcé se déclenche après le timeout.",
      modeForced: 'Arrêt forcé',
      modeForcedHint: 'Coupe le courant immédiatement, comme débrancher la prise.',
      timeout: 'Timeout de fallback (secondes)',
      timeoutHint: "Attente accordée au guest avant de forcer l'arrêt"
    },
    createFromScratch: 'À partir de zéro',
    createFromTemplate: 'Depuis un template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Exécuter le deploy',
      error: 'Deploy échoué',
      compatNote: 'QuickDeploy exige un template compatible QuickDeploy : la plateforme personnalise l\'invité (réseau, domaine, activation) au premier démarrage.',
      template: 'Template',
      noTemplates: 'Aucun template ne déclare encore la compatibilité QuickDeploy — déclarez-la depuis l\'onglet Templates (Linux avec cloud-init, Windows avec cloudbase-init après sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Nom d\'hôte',
      hostnameHint: 'Nom d\'hôte ou FQDN ; vide = le nom de la VM (Windows : 15 caractères au plus)',
      ip: 'Adresse IP',
      ipHint: 'Hôte et préfixe, p. ex. 192.168.122.101/24 ; vide = DHCP',
      gateway: 'Passerelle',
      dns: 'Serveurs DNS',
      dnsHint: 'Jusqu\'à trois, séparés par des virgules',
      count: 'Instances',
      countHint: 'Plus d\'une : nommées <nom>-1…-N, DHCP uniquement',
      user: 'Utilisateur',
      userHint: 'Vide = l\'utilisateur par défaut de l\'image (Linux) ou Administrator (Windows)',
      password: 'Mot de passe',
      passwordHint: 'Écrit dans la user-data générée, que la plateforme déclare ensuite secrète : personne ne la relit',
      sshKeys: 'Clés publiques SSH',
      sshKeysHint: 'Une par ligne (ssh-ed25519 AAAA… commentaire)',
      productKey: 'Clé de produit Windows',
      kmsServer: 'Serveur KMS',
      kmsHint: 'Hôte ou hôte:port — exige une clé de produit (une clé client KMS)',
      adDomain: 'Joindre le domaine Active Directory',
      adDomainHint: 'Vide = pas de jonction au domaine',
      adUser: 'Compte de jonction',
      adPassword: 'Mot de passe du compte de jonction',
      adOu: 'OU cible (facultatif)',
      advanced: 'Avancé : documents bruts',
      userData: 'user-data (brute)',
      userDataHint: 'Supplante la user-data générée : utilisateur, mot de passe, clés et champs Windows ci-dessus doivent rester vides',
      networkConfig: 'network-config (brute)',
      networkConfigHint: 'Supplante le réseau généré : IP, passerelle et DNS ci-dessus doivent rester vides',
      secret: 'Traiter la user-data brute comme secrète',
      secretHint: 'Marquée secrète, l\'API cesse de la renvoyer à quiconque et elle voyage dans le Checkpoint scellée par la masterpass',
      startNow: 'Démarrer tout de suite',
      startNowHint: 'Chaque instance démarre dès qu\'elle est définie ; le seed naît à ce lancement'
    },
    create: {
      nicAttachmentNetwork: 'Réseau logique (fabric)',
      nicNetwork: 'Réseau logique',
      nicNetworkHint: 'La voie RECOMMANDÉE (F3) : la vNIC se réalise sur le bridge DÉRIVÉ du nœud servant — le bridge naît à l\'apply explicite de la fabric, et un démarrage sur un nœud qui ne le porte pas encore refuse en parlant. Quand la dernière référence de la flotte s\'en va, le bridge tombe au prochain apply.',
      button: 'Créer une VM',
      title: 'Créer une machine virtuelle',
      dialogTitle: 'Créer une machine virtuelle',
      stepGeneral: 'Général',
      stepGeneralHint: 'Nom et profil',
      stepCompute: 'CPU et RAM',
      stepComputeHint: 'Topologie et dimensionnement',
      stepDisks: 'Disques',
      stepDisksHint: 'Créer ou attacher',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Lecteurs et supports',
      stepNetwork: 'Réseau',
      stepNetworkHint: 'NIC : trunk ou bridge',
      stepSummary: 'Récapitulatif',
      stepSummaryHint: 'Vérifier et créer',
      name: 'Nom',
      nameHint: 'Minuscules, chiffres et tirets (DNS-1123)',
      nextButton: 'Suivant',
      prevButton: 'Précédent',
      submitButton: 'Créer',
      creating: 'Création…',
      sockets: 'Sockets',
      cores: 'Cores par socket',
      threads: 'Threads par core',
      totalVcpus: 'vCPU totaux',
      memoryGib: 'Mémoire (GiB)',
      cpuModelHint: "'host' expose le CPU de l'host",
      cpuLimitHint: 'Plafond en cores host — vide = illimité',
      cpuNestedHint: "Expose vmx/svm à l'invité pour qu'il exécute son propre hyperviseur — requiert le modèle CPU host et un nœud avec nested activé",
      newDisk: 'Nouveau disque',
      attachDisk: 'Attacher un disque existant',
      diskStorage: 'Storage',
      diskSize: 'Taille (GiB)',
      diskSelect: 'Disque',
      addDisk: 'Ajouter un disque',
      addCdrom: 'Ajouter un lecteur CD/DVD',
      addNic: 'Ajouter une interface réseau',
      remove: 'Retirer',
      slotLimit: 'Limite de slots atteinte',
      cdromImage: 'Image (lecteur vide si absente)',
      nicAttachment: 'Rattachement',
      nicAttachmentTrunk: 'Trunk overlay',
      nicAttachmentBridge: 'Bridge host',
      nicUntagged: 'Overlay untagged',
      nicUntaggedNone: 'Aucun (tagged seulement)',
      nicTrunkHint: 'Au moins un côté : un overlay untagged et/ou des mappings VLAN tagged — la VM ne peut tourner que sur les hosts que chaque overlay référencé déclare',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Réseau overlay',
      addTagged: 'Ajouter un VLAN tagged',
      nicBridge: 'Nom du bridge host',
      nicBridgeHint: 'Bridge NM par nom — la VM ne peut tourner que sur les serveurs dont le host network déclare ce bridge',
      nicMac: 'MAC (auto si vide)',
      noDisksHint: "Aucun disque : la VM n'aura que les lecteurs CD/DVD que vous ajoutez.",
      noCdromsHint: 'Aucun lecteur CD/DVD : ajoutez-en un pour démarrer depuis une image ISO.',
      mountGuestTools: 'Monter TVirt Guest Tools au premier démarrage',
      mountGuestToolsHint: "Place l'ISO avec les drivers virtio et le guest agent dans un lecteur CD vide (ajouté au besoin) — l'installer de Windows en a besoin pour voir les disques.",
      noNicsHint: 'Aucune interface réseau : la VM démarrera sans connectivité.',
      taggedMappings: 'Mappings VLAN tagged',
      summaryDevices: 'Périphériques',
      bootOrderTitle: 'Ordre de boot',
      bootOrderHint: 'Glissez pour réordonner — le premier périphérique démarrable gagne ; les NIC démarrent en PXE',
      bootOrderUp: 'Monter',
      bootOrderDown: 'Descendre',
      createError: 'La création a échoué'
    },
    edit: {
      button: 'Modifier',
      title: 'Modifier la machine virtuelle',
      cancel: 'Annuler',
      save: 'Enregistrer',
      error: 'La modification a échoué',
      modelStoppedOnly: 'Modifiable seulement quand la VM est éteinte',
      firmwareStoppedOnly: 'Firmware modifiable seulement quand la VM est éteinte — le prochain démarrage utilise le nouveau firmware et les variables UEFI sont conservées',
      hugePagesStoppedOnly: 'Modifiable uniquement VM arrêtée — au prochain démarrage la mémoire naît sur le nouveau support',
      runningHint: "Les modifications s'appliquent au prochain power cycle",
      sectionCpu: 'CPU',
      sectionMemory: 'Mémoire',
      sectionPolicy: 'Politiques'
    },
    devices: {
      networkChip: 'réseau fabric',
      title: 'Périphériques',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Ajouter un périphérique USB',
      addUsbTitle: 'Exiger une classe de périphériques USB',
      usbClassHint:
        "La VM demande une CLASSE de périphériques USB (une valeur d'un tag usb-device), jamais un périphérique précis : au démarrage le périphérique libre concret est choisi et réservé sur le nœud. Taggez les périphériques enregistrés dans Cluster › Ressources USB et PCIe.",
      usbTag: 'Tag (usb-device)',
      usbValue: 'Valeur de la classe',
      noUsbTags: 'Aucun tag usb-device — créez-en un et taggez les périphériques enregistrés dans Cluster › Ressources USB et PCIe.',
      noUsbValues: "Ce tag n'a pas encore de valeurs déclarées.",
      usbEmpty: 'Aucune exigence USB — ajoutez une classe pour passer un périphérique au démarrage.',
      usbClassChip: 'classe',
      usbPortChip: 'port',
      usbUnclaimed: 'Aucun périphérique réservé — cela se résout au démarrage de la VM.',
      addGpu: 'Ajouter une GPU',
      addGpuTitle: 'Exiger une classe de GPU',
      gpuClassHint:
        "La VM demande une CLASSE de GPU (une valeur d'un tag gpu-device), jamais une carte précise : au démarrage la carte libre concrète est choisie et réservée sur le nœud, et tout son groupe IOMMU passe ENSEMBLE. Taggez les GPU enregistrées dans Cluster › Ressources USB et PCIe.",
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Valeur de la classe',
      noGpuTags: 'Aucun tag gpu-device — créez-en un et taggez les GPU enregistrées dans Cluster › Ressources USB et PCIe.',
      noGpuValues: "Ce tag n'a pas encore de valeurs déclarées.",
      gpuEmpty: 'Aucune exigence GPU — ajoutez une classe pour passer une carte au démarrage.',
      gpuClassChip: 'classe',
      gpuGroupChip: 'groupe IOMMU ×',
      gpuUnclaimed: 'Aucune carte réservée — cela se résout au démarrage de la VM.',
      gpuPowerCycle: 'Pas de hotplug GPU — les modifications valent à partir du prochain power cycle (PendingRestart)',
      actions: 'Actions',
      attachDisk: 'Ajouter un disque',
      attachDiskTitle: 'Ajouter un disque',
      attach: 'Attacher',
      noFreeDisks: 'Aucun disque non utilisé — créez-en un dans Machines virtuelles › Disques non utilisés.',
      addCdrom: 'Ajouter un lecteur',
      addCdromTitle: 'Ajouter un lecteur CD/DVD',
      editCdromTitle: "Changer l'image CD/DVD",
      changeMedia: "Changer l'image CD/DVD",
      ejectMedium: 'Éjecter',
      mountGuestTools: 'Monter TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools montés',
      guestToolsClickMount: "Place l'ISO TVirt Guest Tools dans le premier lecteur CD/DVD vide",
      guestToolsClickUnmount: 'Cliquez pour éjecter — le lecteur reste, vide',
      guestToolsNoSlot: 'Aucun lecteur CD/DVD vide — ajoutez un lecteur (ou éjectez un support) pour monter les TVirt Guest Tools',
      guestToolsSkew: 'Montée v{pinned} ; le nœud {node} sert désormais la v{current} : éjectez et remontez pour mettre à jour',
      ejectGuestTools: 'Éjecter TVirt Guest Tools (le lecteur reste, vide)',
      guestToolsEjectConfirmTitle: 'Éjecter les TVirt Guest Tools ?',
      guestToolsEjectConfirmBody: 'Le support est éjecté de la VM allumée — le lecteur CD/DVD reste, vide.',
      applyLive: 'Appliquer immédiatement (la VM est allumée)',
      addNic: 'Ajouter une interface',
      addNicTitle: 'Ajouter une interface réseau',
      editNicTitle: "Modifier l'interface réseau",
      bridgeChip: 'bridge',
      cable: 'Câble virtuel',
      plug: 'Brancher le câble virtuel',
      unplug: 'Débrancher le câble virtuel',
      remove: 'Retirer',
      removeTitle: 'Retirer {device} ?',
      removeBody: "Sur une VM allumée, la modification s'applique au prochain power cycle. Les disques et les images sont détachés, jamais supprimés."
    }
  }
}
